var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-editor---image-placeholder",
    transform: "translate(-730.000000, -390.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page@2x",
    transform: "translate(20.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-add-action",
    transform: "translate(710.000000, 290.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    stroke: "currentColor",
    cx: 15,
    cy: 15,
    r: 14.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero",
    points: "12.6 22 14.4 16.75 9 16.75 17.4 8 15.6 13.25 21 13.25"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddAction);
export default __webpack_public_path__ + "static/media/icon-add-action.e742c41861f4aa11d0e3b54b2e3cf102.svg";
export { ForwardRef as ReactComponent };